// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202605081503/js/" + chunkId + "." + {"44":"84166de2","225":"ff068416","481":"7b9fe99a","486":"9db43188","770":"08cc33ba"}[chunkId] + ".0.9969555421511531.chunk.js";
};